// Formateadores compartidos (extraídos de páginas donde estaban duplicados · refactor mecánico)
export const fmtEUR = (v) => new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(v || 0);
export const todayISO = () => new Date().toISOString().slice(0, 10);
